const config = {
  currentLocale: 'en',
  locales: {},
  hasSetAllTranslate: false,
};

function init({ currentLocale, locales }) {
  config.currentLocale = currentLocale;

  // 某些情况下，设置全量翻译会早于 intl init
  // 会造成 init 时的翻译 覆盖了全量的翻译，导致部分翻译拿不到
  if (!config.hasSetAllTranslate) {
    config.locales = locales;
  }
}

function get(key) {
  const locale = config.locales[config.currentLocale];
  return locale?.[key];
}

function setLocales(locales) {
  config.locales = locales || {};
  config.hasSetAllTranslate = true;
}

function setLocale(locale, obj) {
  config.locales[locale] = obj;
}

function getCurrentLocale() {
  return config.locales?.[config.currentLocale] || {};
}

function getLocales() {
  return config.locales;
}

export default {
  init,
  get,
  setLocales,
  getLocales,
  getCurrentLocale,
  setLocale,
};
